import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAtom } from "jotai";
import { allCategoryInfoAtom } from "../atom/calibers";
import useHttp from "./useHttp";

const useCaliberPriceHistory = (period) => {
  const location = useLocation();
  const [allCalibers] = useAtom(allCategoryInfoAtom);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState("idle");
  const { getCalPricingHistory } = useHttp();

  const matchedCaliber = useMemo(() => {
    const pathSegments = location.pathname.split("/").filter(Boolean);

    let caliberFromPath = null;
    if (
      pathSegments.length >= 3 &&
      ["ls", "pd", "brands"].includes(pathSegments[0])
    ) {
      caliberFromPath = pathSegments[2];
    } else if (
      pathSegments.length >= 2 &&
      !["ls", "pd", "brands"].includes(pathSegments[0])
    ) {
      caliberFromPath = pathSegments[1];
    }

    if (!caliberFromPath || allCalibers.length === 0) return null;

    return (
      allCalibers
        .flatMap((item) => item.calibers)
        .find((caliberItem) => caliberItem.seo_caliber === caliberFromPath) ??
      null
    );
  }, [location.pathname, allCalibers]);

  const calId = matchedCaliber ? matchedCaliber.cal_id : null;
  const calName = matchedCaliber ? matchedCaliber.caliber : null;

  useEffect(() => {
    if (!calId) return;

    setLoading("loading");
    getCalPricingHistory(`calid=${calId}&period=${period}`)
      .then((response) => {
        setData(response?.response ?? response);
      })
      .catch((err) => console.error("Error fetching caliber price history:", err))
      .finally(() => setLoading("idle"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [calId, period]);

  return { data, loading, calId, calName };
};

export default useCaliberPriceHistory;
